/**
 * Product feature gates — flip when a surface is ready for users.
 * Align with backend REGISTRATION_ENABLED / PURCHASES_ENABLED / ALLOW_SIMULATED_CHECKOUT
 * (prod defaults: registration off, purchases off, simulated checkout hard-off).
 * Public marketing copy is sales/invite-led when registration is off.
 */

/** Premium section sources beyond generator method + viz catalog (SQL, JSON config, package links). */
export const ADVANCED_SECTION_SOURCES_ENABLED = false;

/**
 * Self-serve signup UI. Default off (sales-led / invite-only); set
 * REACT_APP_REGISTRATION_ENABLED=true to show. Backend still enforces independently.
 */
export const REGISTRATION_ENABLED = process.env.REACT_APP_REGISTRATION_ENABLED === 'true';

/**
 * Marketplace self-serve surfaces. Default off; set REACT_APP_PURCHASES_ENABLED=true to show.
 * In-app upgrade/contact (`/upgrade`) stays available regardless — B2B sales-led flow.
 */
export const PURCHASES_ENABLED = process.env.REACT_APP_PURCHASES_ENABLED === 'true';

/**
 * Product mode: contract/invite onboarding, no public signup or self-serve marketplace.
 * Equivalent to REGISTRATION_ENABLED=false && PURCHASES_ENABLED=false (Oleada 5 B2B-only).
 */
export const B2B_ONLY = !REGISTRATION_ENABLED && !PURCHASES_ENABLED;

/**
 * Simulated checkout UI/API calls. Must stay false unless both this flag and
 * backend ALLOW_SIMULATED_CHECKOUT are true (never in production settings).
 */
export const SIMULATED_CHECKOUT_ENABLED =
  process.env.REACT_APP_ENABLE_SIMULATED_CHECKOUT === 'true';

/** Authenticated upgrade / contact-sales page (B2B). Always routable when logged in. */
export const UPGRADE_PATH = '/upgrade';

/** Public pricing / enterprise landing (invite-only CTA destination). */
export const PUBLIC_PRICING_PATH = '/empresas';

/** Public path for “create account” when self-serve is on; otherwise empresas. */
export function getPublicSignupPath() {
  return REGISTRATION_ENABLED ? '/signup' : PUBLIC_PRICING_PATH;
}

/** In-app destination for “Mejorar plan” / unlock CTAs. */
export function getAppUpgradePath() {
  return UPGRADE_PATH;
}

/**
 * Allow demo/mock indicator figures when public API fails (Landing).
 * Default off — production must not invent macro values. Set
 * REACT_APP_ALLOW_MOCK_DATA=true for local demos only.
 */
export const ALLOW_MOCK_DATA = process.env.REACT_APP_ALLOW_MOCK_DATA === 'true';
